import React from 'react';
import { Box } from '@chakra-ui/react';

import { EquipmentLocation, UserInfo } from '@app/api/models';
import { entityBaseBodyRender, dateTimeBodyRender, TableColumn, booleanBodyRender} from '@app/components/common/table';
import { Txt } from '@app/components/common';

import ViewModal from './modal';
import { OutletColumn } from '../components/outlet-column';

export const columns: TableColumn<EquipmentLocation>[] = [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'type',
    label: 'Тип',
    options: {
      filter: {
        name: 'type_id',
        sourceName: 'equipment_type',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: entityBaseBodyRender(),
    },
  },
  {
    name: 'model',
    label: 'Модель',
    options: {
      filter: {
        name: 'model_id',
        sourceName: 'equipment_model',
        type: 'multi-select',
      },
      sort: true,
      customBodyRender: entityBaseBodyRender(),
    },
  },
  {
    name: 'serial_num',
    label: 'Серийный номер',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'inventory_num',
    label: 'Инв. номер',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'outlet',
    label: 'Торговая точка',
    options: {
      filter: {
        name: 'outlet_id',
        type: 'outlet',
      },
      sort: true,
      customBodyRender: OutletColumn  
    },
  },
  {
    name: 'user',
    label: 'Пользователь',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: UserInfo | null, { rowData }) => {
        if (!value) {return <Txt textColor='var(--chakra-colors-gray-400)'>(пусто)</Txt>;}
        return <Box>
          <Txt textColor='brand-500'>{value?.full_name}</Txt>
        </Box>;
      }
    },
  },
  {
    name: 'transfer_dt',
    label: 'Дата перемещения',
    options: {
      filter: {
        type: 'date',
        name: 'transfer_date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, false),
    },
  },
  {
    name: 'is_efficient',
    label: 'Эффективность',
    options: {
      filter: false,
      sort: false,
      customBodyRender: booleanBodyRender(),
    },
  },
  {
    name: 'history',
    label: 'История транзакций',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_, meta) => {
        return <ViewModal
          title={`${meta.rowData.model.name}: ${meta.rowData.inventory_num} (SN: ${meta.rowData.serial_num})`} 
          id={meta.rowData.id.toString()} 
        />;
      },
    },
  },
];
